import { UserSearchFilter } from 'types/generated/graphql';
import { FiltersParams } from 'types/params';
import { ContentSuggestionParams } from '../types';

const getUserSearchFilterToFilterParams = (
    userSearchFilter: UserSearchFilter,
) => {
    let filterParams;

    switch (userSearchFilter) {
        case UserSearchFilter.Instruments:
            filterParams = FiltersParams.instruments;
            break;
        case UserSearchFilter.Genres:
            filterParams = FiltersParams.genres;
            break;
        case UserSearchFilter.Textsearch:
            filterParams = FiltersParams.textsearch;
            break;
        case UserSearchFilter.Sfxs:
            filterParams = FiltersParams.sfxs;
            break;
        case UserSearchFilter.Tags:
            filterParams = FiltersParams.tags;
            break;
        case UserSearchFilter.SuggestedLabel:
            filterParams = ContentSuggestionParams.suggestedlabels;
            break;
        case UserSearchFilter.SuggestedPack:
            filterParams = ContentSuggestionParams.suggestedpacks;
            break;
        default:
            filterParams = undefined;
    }

    return filterParams;
};

export default getUserSearchFilterToFilterParams;
